export const theme = {
  token: {
    fontFamily: 'Open Sans, sans-serif'
  }
}
